import axios from 'axios'

const state = () => ({
  loaded: false,
  representatives: []
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {
      countries_isoCode: {}
    }
    if (rootState.country !== '') {
      params.countries_isoCode.equals = rootState.country
    }
    return params
  }
}

const mutations = {
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setRepresentative (state, payload) {
    state.representatives = payload
  }
}

const actions = {
  async get ({ commit, getters }) {
    commit('setLoaded', false)
    try {
      const response = await axios.get(window.app.dealersearch_list.api_base + 'dealer-representative/', { params: { ...getters.getParams } })
      commit('setRepresentative', response.data)
      commit('setLoaded', true)
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
